import React, {Component} from 'react';
import Pageheading from '../../widgets/Pageheading';
import {toast} from 'react-toastify';

class GetQuote extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            phone: '',
            message: '',
            submitted: false,
            error: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const {email, phone, message} = this.state;

        try {
            const response = await fetch('https://apis.windeal.co.ke/postdata', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'qyfCv4sBd0fcquNZijY9nhN7szU4a7KS'
                },
                body: JSON.stringify({
                    organisation: 'nafsi',
                    rpcQueue: 'nafsi',
                    menu: 'notification',
                    method: 'saveWebsiteSubmission',
                    type: 'QUOTE',
                    email,
                    phone,
                    message
                })
            });

            const data = await response.json();
            const result = JSON.parse(data.result);

            if (result?.v_field39 === '00') {

                this.setState({
                    email: '',
                    phone: '',
                    message: '',
                    submitted: true
                });

                setTimeout(() => {
                    this.setState({submitted: false});
                }, 5000);
            } else {
                toast.error(
                    data?.v_field48 || 'Failed to submit your request. Please try again.'
                );
            }
        } catch (error) {
            toast.error('Network error. Please check your connection.');
        }
    }

    render() {
        return (
            <div>
                {/*hero section start*/}
                <section className="position-relative">
                    <Pageheading foldername={'Contact'} title={'Get a Quote'}/>
                </section>
                {/*hero section end*/}
                {/*body content start*/}
                <div className="page-content">
                    <section>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10">
                                    <div className="text-center mb-5">
                                        <h2 className="mb-3">Request a Quote</h2>
                                        <p className="lead">Fill in your details and we'll get back to you with a
                                            customized quote for your needs</p>
                                    </div>

                                    {this.state.submitted ? (
                                        <div className="alert alert-success text-center" role="alert">
                                            <h4 className="alert-heading">Thank you!</h4>
                                            <p>Your quote request has been sent. We'll get back to you shortly.</p>
                                        </div>
                                    ) : (
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="form-group">
                                                <label htmlFor="email">Email Address *</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    name="email"
                                                    value={this.state.email}
                                                    onChange={this.handleInputChange}
                                                    required
                                                    placeholder="your.email@example.com"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="phone">Phone Number *</label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    id="phone"
                                                    name="phone"
                                                    value={this.state.phone}
                                                    onChange={this.handleInputChange}
                                                    required
                                                    placeholder="+254 XXX XXX XXX"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="message">Tell us about your requirements *</label>
                                                <textarea
                                                    className="form-control"
                                                    id="message"
                                                    name="message"
                                                    rows="5"
                                                    value={this.state.message}
                                                    onChange={this.handleInputChange}
                                                    required
                                                    placeholder="Please describe your identity verification needs, expected volume, and any specific requirements..."
                                                ></textarea>
                                            </div>
                                            <div className="text-center mt-4">
                                                <button type="submit" className="btn btn-primary btn-lg">
                                                    Submit Request
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {/*body content end*/}
            </div>
        );
    }
}

export default GetQuote;
